// platform/app/src/hooks/useClient.ts
import { useQuery } from '@tanstack/react-query'
import { supabase } from '@loop3/supabase-client'
import type { Client } from '@/lib/types'

export function useClient(prefix: string | undefined) {
  return useQuery({
    queryKey: ['client', prefix],
    queryFn: async (): Promise<Client | null> => {
      const { data, error } = await supabase
        .from('clients')
        .select(
          'id, prefix, internal_id, name, color, sort_order, since_month, notion_url, linear_team_url, github_org_url, account_owner_id, archived_at'
        )
        .eq('prefix', prefix!)
        .maybeSingle()
      if (error) throw error
      return (data ?? null) as Client | null
    },
    enabled: !!prefix,
    staleTime: 60_000,
  })
}
